module.exports = __webpack_public_path__ + "img/item-sale-per-hour.1443900.svg";